import { Auth } from 'aws-amplify'
import axios from 'axios'
import { warningMessage } from 'services/messager'

const DEMANDS_API_URL =
	process.env.REACT_APP_DEMANDS_API_URL ?? 'http://localhost:3333'

const demandsAPI = axios.create({
	baseURL: DEMANDS_API_URL,
})

demandsAPI.interceptors.request.use(async (config) => {
	try {
		let jwtToken = null

		try {
			const session = await Auth.currentSession()
			const accessToken = session.getIdToken()
			jwtToken = accessToken.getJwtToken()
		} catch (errorAuth) {
			const userContracts = JSON.parse(localStorage.getItem('user-contracts'))
			jwtToken = userContracts?.accessToken
		}

		if (!jwtToken) {
			throw new Error('No JWT token found')
		}

		config.headers['Authorization'] = `Bearer ${jwtToken}`
		config.headers['Content-Type'] = 'application/json'
		config.headers['Accept'] = 'application/json'
	} catch (error) {
		console.log(error)
	}
	return config
})

demandsAPI.interceptors.response.use(
	(response) => {
		return response
	},
	(error) => {
		if (error?.response?.status === 401) {
			localStorage.clear()
			warningMessage({
				content:
					'Sua sessão expirou. Faça login novamente para acessar a plataforma.',
			})
			window.location = '/'
		}
	}
)

export default demandsAPI
